"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.useWindowResize = function (callback) {
    var _a = react_1.useState(window.innerWidth), width = _a[0], setWidth = _a[1];
    var _b = react_1.useState(window.innerHeight), height = _b[0], setHeight = _b[1];
    var resize = function () {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
        if (callback)
            callback();
    };
    react_1.useEffect(function () {
        window.addEventListener('resize', resize);
        return function () {
            window.removeEventListener('resize', resize);
        };
    }, []);
    return { windowWidth: width, windowHeight: height };
};
//# sourceMappingURL=UseWindowResize.js.map